import FormHandler from "formhandler.js";

export default {
    init() {

        const contactSubmit = document.querySelector(".js-contact-submit");

        contactSubmit.addEventListener('click', function(event) {
                event.preventDefault();
            }
        );

        this.handleForm();
    },


    handleForm() {
        const $this = this;
        const contactFormHandler = new FormHandler({
            form: {
                block: ".js-contact-form",
                submit: ".js-contact-submit",
                delayForNotice: 100000,
                notice: {
                    appendTo: ".js-contact-notices",
                    message: "Form is invalid. Please check your details and try again.",
                    succesMessage: "Form successfully sent.",
                    errorMessage: "Oops, something went wrong. Please try again later.",
                }
            },
            fields: {
                "name": {
                    validation: "isNonEmpty"
                },
                "email": {
                    validation: "isEmail"
                },
                "category": {
                    validation: "isSelected",
                    message: "Please select a category"
                },
                "message": {
                    validation: "isMessage"
                }
            },
            customValidations: {
                isMessage: function (node) {
                    let valid;
                    let message;

                    if (node.value === "") {
                        valid = false;
                        message = 'The field value is required';
                    }

                    return {
                        valid,
                        message,
                    };
                },
            },
            callbacks: {
                onSubmit(form, fields) {
                    testValidity(form);
                },
            },
        });

        function testValidity(form) {
            if(contactFormHandler.isFormValid() === true) {
                $this.submit(form);
            }
        }

    },

    submit(form) {
        form.submit()
    }
};
